module.exports = require("./bs-Latn.d.ts");